import axios from "axios";
import { Constants } from '../utils/Constants';

export function login(fog_cnpj, password) {
	return axios.post(`${Constants.baseUrl}/auth`, { fog_cnpj, password });
}
